import { render, staticRenderFns } from "./browse-configurations-form.view.vue?vue&type=template&id=71236cb4&scoped=true"
import script from "./browse-configurations-form.view.vue?vue&type=script&lang=ts"
export * from "./browse-configurations-form.view.vue?vue&type=script&lang=ts"
import style0 from "./browse-configurations-form.view.vue?vue&type=style&index=0&id=71236cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71236cb4",
  null
  
)

export default component.exports